import RefundSummaryItem from '@/components/manage/refund/summary/RefundSummaryItem';
import { TransText } from '@/i18n/trans/text';
import { type AdmissionDTO, type RefundOffersDTO } from '@/types/dto/agent';
import { Divider, Icons, Typography } from '@fleet/webshop-ui';
import { type FC } from 'react';

interface RefundSummaryProps {
  refundSummary: RefundOffersDTO;
  admissions: Array<AdmissionDTO>;
}

const RefundSummary: FC<RefundSummaryProps> = ({
  refundSummary: { refundOffers },
  admissions,
}) => {
  const { refundableAmount, refundFee } = refundOffers?.[0] ?? {};

  const totalAdmissionAmount = admissions.reduce((sum, admission) => {
    const admissionPrice = admission.price?.amount ?? 0;
    const ancillariesPrice =
      admission.ancillaries?.reduce(
        (acc, ancillary) => acc + (ancillary.price?.amount || 0),
        0
      ) || 0;

    return sum + admissionPrice + ancillariesPrice;
  }, 0);

  const getRefundFeeAmount = (amount?: number) =>
    amount ? Number(`-${amount}`) : 0;

  return (
    <>
      <div className="mb-5">
        <Typography variant="paragraph">
          <TransText i18nKey="refundIssuedText" />
        </Typography>
        <div className="mt-5 flex flex-col gap-2 rounded-lg rounded-b-none border border-neutral-light px-4 py-3">
          <RefundSummaryItem
            icon={
              <Icons.ticketReturn
                height={16}
                width={16}
                className="text-primary"
              />
            }
            title={<TransText i18nKey="totalPrice" />}
            amount={totalAdmissionAmount}
          />
          <RefundSummaryItem
            icon={
              <Icons.coin height={16} width={16} className="text-primary" />
            }
            title={<TransText i18nKey="refundFee" />}
            amount={getRefundFeeAmount(refundFee?.amount)}
          />
        </div>
        <div className="rounded-md rounded-t-none border border-t-0 border-neutral-light bg-primary-pale p-4">
          <RefundSummaryItem
            icon={
              <Icons.buyReturnTicket
                className="text-primary"
                width={16}
                height={16}
              />
            }
            title={<TransText i18nKey="totalRefund" />}
            amount={refundableAmount?.amount}
            isTotal
          />
        </div>
      </div>
      <Divider />
    </>
  );
};

export default RefundSummary;
